import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { debounce } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "EditableDescription",
  props: {
    description: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    noMargin: {
      type: Boolean,
      default: false
    },
    label: {
      type: Boolean,
      default: true
    },
    forceEdit: {
      type: [Boolean, null],
      default: null
    },
    noaIssue: {
      type: [String, null],
      default: null
    }
  },
  data() {
    return {
      editing: false,
      newDescription: ""
    };
  },
  computed: {
    forceEditMode() {
      return this.forceEdit !== null;
    },
    emptyDescriptionText() {
      return this.forceEditMode ? this.$t("email.messages.noCalendarDescription") : this.$t("global.actions.clickHereTo", {
        item: this.$t("global.words.edit")
      });
    }
  },
  watch: {
    forceEdit: {
      handler(value) {
        this.editing = value;
      },
      immediate: true
    },
    editing: {
      handler(value) {
        if (value) {
          var _this$description;
          this.newDescription = (_this$description = this.description) == null ? void 0 : _trimInstanceProperty(_this$description).call(_this$description);
          this.$nextTick(() => {
            var _this$$refs$descripti;
            (_this$$refs$descripti = this.$refs.descriptionInput) == null ? void 0 : _this$$refs$descripti.focus();
          });
        }
        if (value !== this.forceEdit) this.$emit("update:forceEdit", value);
      },
      immediate: true
    }
  },
  methods: {
    toggleEditing(value) {
      this.editing = value != null ? value : !this.editing;
    },
    handleDescriptionChange(event) {
      var _event$target$value, _event$target;
      const value = (_event$target$value = event == null ? void 0 : (_event$target = event.target) == null ? void 0 : _event$target.value) != null ? _event$target$value : "";
      this.newDescription = _trimInstanceProperty(value).call(value);
      if (this.forceEditMode) {
        this.$emit("save", {
          description: this.newDescription
        });
      }
    },
    handleClickOutside: debounce(function () {
      if (!this.editing || this.forceEditMode) return;
      this.$emit("save", {
        description: this.newDescription
      });
      this.toggleEditing(false);
    }, 200)
  }
});